module.exports = __webpack_public_path__ + "static/media/deappoolHero.fe8f1b86.png";